import { useTranslate } from '@refinedev/core';
import { Segmented } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useMobilePreview } from './mobilePreviewContext';
import type { MobileTheme } from './constants';

/** Labeled phone-theme switch, for panels with room for words.
 * `MobileThemeToggle` stays for the icon-sized spots. */
export const MobileThemeSegmented = () => {
  const t = useTranslate();
  const { mobileTheme, setMobileTheme } = useMobilePreview();

  return (
    <Segmented<MobileTheme>
      size="small"
      value={mobileTheme}
      onChange={setMobileTheme}
      options={[
        {
          value: 'light',
          label: t('base.mobile_preview.theme.light'),
          icon: <SunOutlined />,
        },
        {
          value: 'dark',
          label: t('base.mobile_preview.theme.dark'),
          icon: <MoonOutlined />,
        },
      ]}
    />
  );
};
